import React from 'react';
import { marked } from 'marked';

// Renders CMS markdown. Content comes from our own repo, so raw HTML is fine.
const render = (md) => marked.parse(md || '', { breaks: true }).replace(/<a href="http/g, '<a target="_blank" rel="noopener noreferrer" href="http');

const Markdown = ({ children, className }) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: render(children) }} />
);

export default Markdown;
